import React from "react"
import ShelfRenderer from "../components/ShelfRenderer"
import SEO from "../components/seo"
import { DFPSlotsProvider } from "react-dfp"
import HighlightBanner from "../components/HighlightBanner"
import TrueCIBar from "./TrueCIBar"
import AdSlotBlock from "../components/AdSlotBlock"

const PageRendererTemplate = ({ pageContext }: any) => {
  const {
    content: { shelves, highlightBanner },
    withAds,
    categories,
    seo: { title, keywords, description, ogImage, siteTitle },
  } = pageContext
  const createViewMoreLink = (viewMoreCategory: string) => {
    const category = categories.find(
      ({ label }: any) => label === viewMoreCategory
    )
    if (category) {
      return `/content/${category.name}`
    } else {
      return undefined
    }
  }

  return (
    <div>
      <SEO
        siteTitle={siteTitle}
        title={title}
        description={description}
        ogImage={ogImage}
        keywords={keywords}
      />
      <DFPSlotsProvider
        dfpNetworkId="32036410"
        autoLoad={true}
        collapseEmptyDivs
        singleRequest={false}
      >
        <>
          <HighlightBanner
            banners={
              highlightBanner && highlightBanner.banners
                ? highlightBanner.banners
                : []
            }
          />
          {/* <TrueCIBar /> */}
          {withAds && <AdSlotBlock type={"billboard"} />}
          {shelves.map((shelf: any, index: number) => (
            <React.Fragment key={shelf.id}>
              <ShelfRenderer
                key={shelf.id}
                shelf={{
                  ...shelf,
                  withAds: index === 1 || index === 5,
                  contentType: shelf.textAlignment
                    ? "textCombo"
                    : shelf.contentType,
                  viewMoreLink: createViewMoreLink(shelf.viewMoreCategory),
                }}
              />
              {index === 1 && withAds && <AdSlotBlock type={"billboard2"} />}
              {index === 3 && withAds && <AdSlotBlock type={"billboard3"} />}
            </React.Fragment>
          ))}
        </>
      </DFPSlotsProvider>
    </div>
  )
}

export default PageRendererTemplate
